<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="currency_page.list_title" />

    <CurrencyList
      :currencies="filteredCurrencies"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteCurrency"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateCurrencyModal
      :open="showModal"
      :is-edit="!!selectedCurrency"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveCurrency"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateCurrencyModal from "../../components/Settings/Currency/CreateCurrencyModal.vue";
import CurrencyList from "../../components/Settings/Currency/CurrencyList.vue";
import { useCurrency } from "../../composables/useCurrency";

const {
  searchQuery,
  filteredCurrencies,
  showModal,
  selectedCurrency,
  form,
  errors,
  loading,
  paginationConfig,
  fetchCurrencies,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  saveCurrency,
  deleteCurrency,
} = useCurrency();

onMounted(fetchCurrencies);
</script>
